"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAcceptedOffers = exports.GetDeploymentIndexersByIndexer = exports.GetDeploymentIndexer = exports.GetDeploymentIndexers = exports.GetDeployment = exports.DeploymentIndexerFields = exports.MetadataFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.MetadataFields = (0, graphql_tag_1.default) `
  fragment MetadataFields on IndexerMetadatum {
    metadataCID
    name
    url
  }
`;
exports.DeploymentIndexerFields = (0, graphql_tag_1.default) `
  fragment DeploymentIndexerFields on DeploymentIndexer {
    id
    indexerId
    deploymentId
    blockHeight
    timestamp
    status
    indexer {
      metadata {
        ...MetadataFields
      }
    }
  }
  ${exports.MetadataFields}
`;
exports.GetDeployment = (0, graphql_tag_1.default) `
  query GetDeployment($deploymentId: String!) {
    deployment(id: $deploymentId) {
      id
      version
      project {
        id
        metadata
      }
    }
  }
`;
exports.GetDeploymentIndexers = (0, graphql_tag_1.default) `
  query GetDeploymentIndexers($offset: Int, $deploymentId: String!) {
    deploymentIndexers(
      first: 20
      offset: $offset
      filter: { deploymentId: { equalTo: $deploymentId }, status: { notEqualTo: TERMINATED } }
    ) {
      totalCount
      nodes {
        ...DeploymentIndexerFields
      }
    }
  }
  ${exports.DeploymentIndexerFields}
`;
exports.GetDeploymentIndexer = (0, graphql_tag_1.default) `
  query GetDeploymentIndexer($indexerAddress: String!, $deploymentId: String!) {
    deploymentIndexers(
      filter: { indexerId: { equalTo: $indexerAddress }, deploymentId: { equalTo: $deploymentId } }
    ) {
      totalCount
      nodes {
        ...DeploymentIndexerFields
      }
    }
  }
  ${exports.DeploymentIndexerFields}
`;
exports.GetDeploymentIndexersByIndexer = (0, graphql_tag_1.default) `
  query GetDeploymentIndexersByIndexer($indexerAddress: String!) {
    deploymentIndexers(filter: { indexerId: { equalTo: $indexerAddress } }) {
      totalCount
      nodes {
        ...DeploymentIndexerFields
        deployment {
          id
          project {
            id
            metadata
          }
        }
      }
    }
  }
  ${exports.DeploymentIndexerFields}
`;
exports.GetAcceptedOffers = (0, graphql_tag_1.default) `
  query GetAcceptedOffers($address: String!, $offerId: String!) {
    acceptedOffers(filter: { indexerId: { equalTo: $address }, offerId: { equalTo: $offerId } }) {
      totalCount
      nodes {
        id
      }
    }
  }
`;
//# sourceMappingURL=deployments.generated.js.map